module.exports = __webpack_public_path__ + "media/images/pc/top/recommend_plan_photowedding-1091d67884e8f31c95fc14574ed7d5e0.webp";